import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { CallCenterDetailsComponent } from "./call-center-details/call-center-details.component";
import { CallHistoryComponent } from "./call-history/call-history.component";
import { PatientDashboardComponent } from "./patient-dashboard/patient-dashboard.component";

const routes: Routes = [
  {
    path: "",
    component: CallCenterDetailsComponent,
    children: [
      {
        path: "call-history",
        component: CallHistoryComponent,
      },
      {
        path: "",
        loadChildren: () =>
          import(
            "./call-center-inbound-call/call-center-inbound-call/call-center-inbound-call.module"
          ).then((m) => m.CallCenterInboundCallModule),
      },
      {
        path: "",
        loadChildren: () =>
          import(
            "./call-center-dailer/call-center-dialer/call-center-dialer.module"
          ).then((m) => m.CallCenterDialerModule),
      },
      {
        path: "patient-dashboard",
        component: PatientDashboardComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactRoutingModule {}
